import { UtilDocumentId } from '@formbird/shared';
import { Injectable } from '@angular/core';
import { OfflineStatusService } from '../offline-status/offline-status.service';
import { WebWorkerMessageType } from '../offline/offline-web-worker-message.type';
import { ConfigService } from '../config/config.service';
import { ClientConstants } from '../../constants/ClientConstants';
import { BroadcastService } from '../broadcast/broadcast.service';
import { UtilWebWorker } from '../../utils/UtilWebWorker';
import { NotificationService } from '../notification/notification.service';
import { LoggedInUserService } from '../user/logged-in-user.service';
import { IndexedDBService } from '../indexeddb/indexed-db.service';
import { RestDataService } from '../data/rest-data.service';
import { CurrentDocumentService } from '../document/current-document.service';

const logger = console;
@Injectable({
  providedIn: 'root'
})
export class OfflineUtilService {
  private isPendingPreviousSync = false;

  constructor(
    private offlineStatusService: OfflineStatusService,
    private broadcastService: BroadcastService,
    private configService: ConfigService,
    private notificationService: NotificationService,
    private loggedInUserService: LoggedInUserService,
    private indexedDBService: IndexedDBService,
    private restDataService: RestDataService,
    private currentDocumentService: CurrentDocumentService
  ) { }

  getNextId(url?) {
    return UtilDocumentId.generateId();
  }

  async startOfflinePoller() {
    const _self = this;

    let offlinePollerWorker: any;

    const processPoller = () => {

      console.debug('...Processing poller');

      const pollerOptions: any = {};
      pollerOptions.offlinePollerStart = true;
      pollerOptions.unsyncedRecordCheckTime = this.configService.clientConfig().unsyncedRecordCheckTime;

      setTimeout(function () {
        offlinePollerWorker.postMessage(pollerOptions);
      }, 5000);

      _self.broadcastService.on(ClientConstants.CHECK_UNSYNCED_DOCUMENTS).subscribe(data => {
        if (!_self.isPendingPreviousSync) {
          pollerOptions.checkUnsyncedDocuments = true;
          offlinePollerWorker.postMessage(pollerOptions);
          _self.isPendingPreviousSync = true;
        }

      });

      offlinePollerWorker.onmessage = onMessage;
      async function onMessage({ data }) {
        if (data?.messageType === WebWorkerMessageType.PEINDING_DOCUMENT_COUNT) {
          _self.offlineStatusService.setPendingDocumentCount(data.value);
        } else if (data?.messageType === WebWorkerMessageType.PREVIOUS_SYNC_STATUS) {
          if (data?.value === 'completed') {
            _self.isPendingPreviousSync = false;
          } else {
            _self.notificationService.error(data?.value);
            _self.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs.push(data?.value);
            _self.loggedInUserService.setUserConfigItem('ErrorOfflineChangesSyncDocs',
              _self.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs);
          }
        } else if (data?.messageType === WebWorkerMessageType.PRINT_MESSAGE) {
          const args = data.value;
          _self.notificationService.printMessage(args.message, args.options, args.title, args.position,
            args.preventDuplicate, args.displayDesktopNotification, args.onClickFunction,
            args.timeOut, args.isPermanent, args.customClassName);
        } else if (data?.messageType === WebWorkerMessageType.GATEWAY_ERROR) {
          _self.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs.push(data?.value);
          _self.loggedInUserService.setUserConfigItem('ErrorOfflineChangesSyncDocs',
            _self.offlineStatusService.offlineStatus.errorOfflineChangesSyncDocs);
        } else if (data?.messageType === WebWorkerMessageType.FATAL_ERROR) {
          const args = data?.value;

          if (args?.offline?.type === "PUT") {
            //10190 note id 97106 if the save is an update to a document that already existed on the server that the current version is reset
            //back to what the current version is on the server
            _self.indexedDBService.documentReset(args?.documentId);
            const document = await _self.restDataService.getDocument(args?.documentId);
            await _self.indexedDBService.doCacheDocument(document, null);
          }
        }
      }
    };

    const userAgent = navigator.userAgent
    if (/android/i.test(userAgent) && (/chrome/i.test(userAgent))) {
      // Use Web Locks API to ensure a single worker instance
      const lockName = 'offline-poller';
      const lockAcquired = await navigator.locks.request(lockName, async (lock) => {
        console.log('Lock acquired. Initializing Web Worker for OfflinePoller.js.');
        offlinePollerWorker = await UtilWebWorker.initWebWorker('OfflinePoller.js');

        processPoller();

        // Keep the lock active until the tab is closed
        window.addEventListener('beforeunload', () => {
          console.log('Tab is closing. Releasing the lock and terminating the worker.');
          offlinePollerWorker.terminate();
        });

        await new Promise(() => {
          console.log('Lock is persistently held until the tab is closed.');
        });

        return true; // This line is never actually reached, but ensures structure.
      });

      if (!lockAcquired) {
        console.log('Worker is already running in another tab.');
      }
    } else {
      
      console.debug('...Starting offline poller in offline util service');

      offlinePollerWorker = await new SharedWorker('OfflinePoller.js').port;
      offlinePollerWorker.start();

      processPoller();
    }
  }

}
